import React from 'react';

export default function ({ children, header = null }) {
    return (
        <div
            className="p-datatable p-component p-datatable-responsive-scroll"
            data-scrollselectors=".p-datatable-wrapper"
            data-pc-name="datatable"
            data-pc-section="root"
            pr_id_405=""
        >
            <div
                className="p-datatable-wrapper"
                data-pc-section="wrapper"
                style={{ overflow: 'auto' }}
            >
                    {header}

                <table className="p-datatable-table" role="table" data-pc-section="table">
                    {children}
                </table>
            </div>
        </div>
    );
}
